import apiClient from './apiClient';

export async function listInactive(customerIds) {
  const res = await apiClient.post('/inactive-customers/list', { customerIds });
  return res.data.data;
}

export async function addReason(name) {
  const res = await apiClient.post('/inactive-customers/reasons', { name });
  return res.data.data;
}

export async function setReason(customerId, reasonId) {
  const res = await apiClient.put(`/inactive-customers/customers/${customerId}/reason`, { reasonId: reasonId || null });
  return res.data.data;
}

export async function removeReason(reasonId) {
  const res = await apiClient.delete(`/inactive-customers/reasons/${reasonId}`);
  return res.data.data;
}
